<p-panel [toggleable]="true" [collapsed]="shouldBeCollapsed">
  <ng-template #header
    ><div><i class="pi pi-list mr-3"></i>Main Controller</div></ng-template
  ><p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="tableData()"
  >
    <ng-template #header>
      <tr>
        <th>Description</th>
        <th>Specification</th>
      </tr>
    </ng-template>
    <ng-template #body let-field let-rowIndex="rowIndex">
      <tr>
        <td>{{ field.description }}</td>
        @if(rowIndex === 0){
        <td
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(field.specification)
          "
        >
          <i
            [class]="iconsStyles.getDeviceStatusIcon(field.specification)"
            class="mr-2"
          ></i
          >{{ field.specification }}
        </td>
        } @else {
        <td>{{ field.specification }}</td>
        }
      </tr>
    </ng-template>
  </p-table></p-panel
>
